import React from 'react';
import PropTypes from 'prop-types';
import style from './notification.module.less';

export const NotificationImage = ({ image = '', imageAltText = '' }) => {
  if (!image) {
    return null;
  }
  return (
    <div className={style['img-container']}>
      <div className={style.image} style={{ backgroundImage: `url(${image})` }} title={imageAltText} />
    </div>
  );
};

NotificationImage.propTypes = {
  image: PropTypes.string,
  imageAltText: PropTypes.string,
};
